import * as React from 'react';

function SvgListingManagement(props) {
  return (
    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none">
        <path
          d="M37.644 37.638V16.664a2.328 2.328 0 00-2.328-2.328h-6.998V7.344a2.328 2.328 0 00-2.328-2.328H9.679a2.325 2.325 0 00-2.335 2.328v30.294H6.18c-.645 0-1.164.52-1.164 1.164 0 .644.52 1.164 1.164 1.164h32.628c.645 0 1.164-.52 1.164-1.164 0-.645-.52-1.164-1.164-1.164h-1.164z"
          fill="#E2F4F2"
        />
        <path
          d="M4.679.016h16.31c1.23 0 2.242.954 2.324 2.169l.005.16v6.99h6.998c1.23 0 2.24.955 2.322 2.17l.006.159v20.974h1.164c.645 0 1.164.52 1.164 1.164 0 .601-.452 1.094-1.037 1.157l-.127.007H1.18c-.645 0-1.164-.52-1.164-1.164 0-.602.453-1.095 1.037-1.158l.127-.006h1.164V2.344c0-1.235.96-2.247 2.175-2.323l.16-.005h16.31zm15.303 2.322H5.687c-.52 0-.948.393-1.002.898l-.006.11v29.292h16.31V3.346c0-.557-.45-1.008-1.007-1.008zm9.32 9.326h-4.976c-.52 0-.947.392-1.002.898l-.006.11v19.966h6.991V12.672c0-.557-.45-1.008-1.007-1.008zm-11.811 9.32c.645 0 1.17.519 1.164 1.164 0 .644-.52 1.164-1.164 1.164h-9.32c-.644 0-1.164-.52-1.164-1.164 0-.645.52-1.165 1.164-1.165zm-9.32-6.992h9.32c.645 0 1.17.52 1.164 1.164 0 .602-.452 1.095-1.037 1.158l-.127.007h-9.32c-.644 0-1.164-.52-1.164-1.165 0-.601.453-1.094 1.037-1.157l.127-.007h9.32zm0-6.991h9.32c.645 0 1.17.52 1.164 1.164 0 .602-.452 1.095-1.037 1.158l-.127.006h-9.32c-.644 0-1.164-.52-1.164-1.164 0-.602.453-1.094 1.037-1.157L8.171 7h9.32z"
          fill="#38B2A6"
        />
      </g>
    </svg>
  );
}

export default SvgListingManagement;
